import { translate } from "app/filters/i18nFilter";
import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import type { FilterValueLifecycleStatus } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";

import { getFormattedRangeValue } from "./rangeValueFormatters";
import { getFilterChipTranslationKey } from "./translationUtils";

export const createRangeChipItem = <T extends Record<string, unknown>>(
    field: keyof T,
    formatter: (value: number | string) => string,
    options: Record<keyof T, readonly number[]>,
    value: Partial<T> | undefined,
    getLifecycleStatus?: (value: Partial<T>) => FilterValueLifecycleStatus,
): ChipItem | null => {
    if (!value || !value[field]) {
        return null;
    }

    const fieldName = translate(getFilterChipTranslationKey(field as string));
    return {
        id: field as string,
        text: `${fieldName}: ${getFormattedRangeValue(formatter, options[field], value[field])}`,
        chipStatus: getLifecycleStatus?.({ [field]: value[field] } as Partial<T>),
    };
};
